import logo from './logo.svg';
import './App.css';
import { render } from 'react-dom';
import React from 'react';
import ChatBotFinal from './components/Chat-final';

function App() {
  return (
    <div className="App">
      <head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Gothic+A1:wght@500&family=Noto+Sans+KR:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      </head>
      <body id="body">
        <ChatBotFinal/>
      </body>
      <footer/>
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js